import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { RestService } from "./services/rest.service";
import { RestOperatorsService } from "./services/rest-operators.service";
import { DataService } from "./services/data.service";

@NgModule({
    imports: [
        HttpModule
    ],
    providers: [
        DataService,
        RestService,
        RestOperatorsService
    ]
})
export class CoreModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/core.module.ts
 **/